import React from 'react';
import { Form, Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import BookNavigationTabItems from '../bookingTypeNavigationTabItems/BookNavigationTabItems';
import { createCustomerStatement } from '../../../../../../../../services/customer/ticketBookingServices';
import statementBookingSeats from '../../../../../../../../utils/functions/booking/statementBookingSeats';
import BookingNavigationButtons from '../BookingNavigationButtons';
import ChosenRideDetails
  from '../../../../../../components/drawers/ticketSearchDrawers/ticketSearchFormDrawer/components/ChosenRideDetails';

function BookBookingNavigation({ outline = true }) {
  const {
    activeStep,
    setActiveStep,
    departureClassesForm,
    returnClassesForm,
    bookingData,
    bookingInfoForm,
    options,
  } = useBooking();

  const isReturnWay = Boolean(bookingData?.return?.id);
  const departureClasses = Form.useWatch('classes', departureClassesForm);
  const returnClasses = Form.useWatch('classes', returnClassesForm);
  const amountOfDepartureClasses = departureClasses
    ?.reduce((acc, cur) => acc + (cur.amount ? cur.amount * 1 : 0), 0);
  const amountOfReturnClasses = returnClasses
    ?.reduce((acc, cur) => acc + (cur.amount ? cur.amount * 1 : 0), 0);
  const lastStep = isReturnWay ? 3 : 2;

  const navigate = useNavigate();

  const submitBooking = async () => {
    const bookedStatement = await createCustomerStatement(
      statementBookingSeats({
        bookingData,
        departureClasses,
        departureClassesForm,
        returnClasses,
        bookingInfoForm,
        options,
      }),
    );
    if (bookedStatement?.id) {
      navigate('/ka/profile?tab=booked-statements');
    }
  };

  // Define handlers for each step in the process
  const nextStepHandlers = {
    1: async () => {
      await bookingInfoForm.validateFields();
      setActiveStep(2);
    },
    2: async () => {
      await departureClassesForm.validateFields();
      if (amountOfDepartureClasses > 9) {
        if (isReturnWay) {
          setActiveStep(3);
        } else {
          await submitBooking();
        }
      }
    },
    3: async () => {
      await returnClassesForm.validateFields();
      if (amountOfReturnClasses > 9) {
        await submitBooking();
      }
    },
  };

  const handleNextStep = () => {
    nextStepHandlers[activeStep]();
  };

  const handlePreviousStep = () => {
    setActiveStep((prev) => prev - 1);
  };

  return (
    <div className={`flex flex-col grow p-8 rounded-2xl bg-white ${outline && 'outline-border'} !sticky top-[300px]`}>
      {(bookingData?.departure || bookingData?.return) && (
      <div className="mb-4 hidden lg:flex flex-col gap-3">
        {bookingData?.departure && <ChosenRideDetails chosenRide={bookingData?.departure} />}
        {bookingData?.return && <ChosenRideDetails chosenRide={bookingData?.return} />}
      </div>
      )}
      <Tabs className="no-tablist" items={BookNavigationTabItems()} activeKey={activeStep} />
      <BookingNavigationButtons
        handlePreviousStep={handlePreviousStep}
        handleNextStep={handleNextStep}
        activeStep={activeStep}
        isNextDisabled={amountOfDepartureClasses < 10
              || (activeStep > 1 && isReturnWay && returnClasses < 10)}
        lastStep={lastStep}
      />
    </div>
  );
}

export default BookBookingNavigation;
